import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "profilePurchaseHistoryPage",
  class: "container mb-3"
}
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-lg-8 col col-sm-12 profile-page" }
const _hoisted_4 = { class: "purchase-history__main-wrapper" }
const _hoisted_5 = { class: "purchase-history__header-wrapper" }
const _hoisted_6 = { class: "purchase-history__header" }
const _hoisted_7 = {
  key: 0,
  class: "purchase-history__ticket-wrapper col-12"
}
const _hoisted_8 = { class: "purchase-history__ticket" }
const _hoisted_9 = { class: "purchase-history__ticket__top" }
const _hoisted_10 = {
  class: "purchase-history__ticket__top__id",
  dir: "ltr"
}
const _hoisted_11 = { class: "purchase-history__ticket__top__actions-wrapper" }
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["onClick"]
const _hoisted_15 = { class: "purchase-history__ticket__mid" }
const _hoisted_16 = { class: "purchase-history__ticket__mid-inner" }
const _hoisted_17 = { class: "purchase-history__ticket__mid-inner__title" }
const _hoisted_18 = { class: "purchase-history__ticket__mid-inner__date" }
const _hoisted_19 = { class: "purchase-history__ticket__bot" }
const _hoisted_20 = {
  class: "purchase-history__ticket__bot__time",
  DIR: "ltr"
}
const _hoisted_21 = { class: "purchase-history__ticket__bot__pickup" }
const _hoisted_22 = { class: "purchase-history__ticket__bot__pickup__info" }
const _hoisted_23 = { class: "purchase-history__ticket__bot__pickup" }
const _hoisted_24 = { class: "purchase-history__ticket__bot__pickup__info" }
const _hoisted_25 = { class: "purchase-history__ticket__bot__price" }
const _hoisted_26 = { dir: "ltr" }
const _hoisted_27 = {
  key: 1,
  class: "purchase-history__ticket-wrapper col-12"
}
const _hoisted_28 = { class: "purchase-history__ticket" }
const _hoisted_29 = { class: "purchase-history__ticket__top" }
const _hoisted_30 = {
  class: "purchase-history__ticket__top__id align-items-center",
  dir: "ltr"
}
const _hoisted_31 = { class: "purchase-history__ticket__top__actions-wrapper" }
const _hoisted_32 = ["onClick"]
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { class: "purchase-history__ticket__mid" }
const _hoisted_35 = { class: "purchase-history__ticket__mid-inner" }
const _hoisted_36 = { class: "purchase-history__ticket__mid-inner__title" }
const _hoisted_37 = { class: "purchase-history__ticket__mid-inner__date" }
const _hoisted_38 = { class: "purchase-history__ticket__bot" }
const _hoisted_39 = {
  class: "purchase-history__ticket__bot__time",
  DIR: "ltr"
}
const _hoisted_40 = { class: "purchase-history__ticket__bot__pickup" }
const _hoisted_41 = { class: "purchase-history__ticket__bot__price" }
const _hoisted_42 = { dir: "ltr" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomerProfileNavComponent = _resolveComponent("CustomerProfileNavComponent")!

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_CustomerProfileNavComponent, {
        id: "sideNav",
        class: "col-lg-4 col-sm-12 side-nav"
      }),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.$t('profile_order_history_page_title')), 1)
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.bookings, (booking) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
              (booking.service_type === _ctx.ServiceTypes.SERVICE_RENT)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_9, [
                          _createElementVNode("span", _hoisted_10, _toDisplayString('Nr. ' + booking.id) + " - " + _toDisplayString(_ctx.$t('vehicle_rent')) + " (" + _toDisplayString(booking.created_at.split('T')[0]) + ")", 1),
                          _createElementVNode("div", _hoisted_11, [
                            (!booking.payment && _ctx.isBookingPickupDateLaterThanToday(booking))
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  class: "purchase-history__ticket__top__actions",
                                  onClick: ($event: any) => (_ctx.handlePayTheBooking(booking))
                                }, _toDisplayString(_ctx.$t('pay_order')), 9, _hoisted_12))
                              : _createCommentVNode("", true),
                            (booking.receipt)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 1,
                                  class: "purchase-history__ticket__top__actions",
                                  onClick: ($event: any) => (_ctx.handleDownloadInvoiceAndPreInvoice(booking.pre_invoice_url!, booking.pre_invoice_file_name!))
                                }, _toDisplayString(_ctx.$t('pre_invoice')), 9, _hoisted_13))
                              : _createCommentVNode("", true),
                            (booking.payment)
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 2,
                                  class: "purchase-history__ticket__top__actions",
                                  onClick: ($event: any) => (_ctx.handleDownloadInvoiceAndPreInvoice(booking.invoice_url!, booking.invoice_file_name!))
                                }, _toDisplayString(_ctx.$t('invoice')), 9, _hoisted_14))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_15, [
                          _createElementVNode("div", _hoisted_16, [
                            _createElementVNode("span", _hoisted_17, _toDisplayString(booking.vehicle.make + ' ' + booking.vehicle.model + ' ' + _ctx.$t('rent')), 1),
                            _createElementVNode("span", _hoisted_18, _toDisplayString(booking.journey_date), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("div", _hoisted_21, [
                              _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"purchase-history__ticket__bot__pickup__icon\"><svg width=\"28\" height=\"28\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12.6667 2.66675H3.33333C2.59695 2.66675 2 3.2637 2 4.00008V13.3334C2 14.0698 2.59695 14.6667 3.33333 14.6667H12.6667C13.403 14.6667 14 14.0698 14 13.3334V4.00008C14 3.2637 13.403 2.66675 12.6667 2.66675Z\" stroke=\"#6C727A\" stroke-width=\"1.6\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M10.6667 1.33325V3.99992\" stroke=\"#6C727A\" stroke-width=\"1.6\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M5.33334 1.33325V3.99992\" stroke=\"#6C727A\" stroke-width=\"1.6\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M2 6.66675H14\" stroke=\"#6C727A\" stroke-width=\"1.6\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg></div>", 1)),
                              _createElementVNode("div", _hoisted_22, [
                                _createElementVNode("span", null, _toDisplayString(_ctx.$t('i_will_take')), 1),
                                _createElementVNode("span", null, _toDisplayString(_ctx.ensureDateTimeFormat(booking.pickup)), 1)
                              ])
                            ]),
                            _createElementVNode("div", _hoisted_23, [
                              _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"purchase-history__ticket__bot__pickup__icon\"><svg width=\"28\" height=\"28\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12.6667 2.66675H3.33333C2.59695 2.66675 2 3.2637 2 4.00008V13.3334C2 14.0698 2.59695 14.6667 3.33333 14.6667H12.6667C13.403 14.6667 14 14.0698 14 13.3334V4.00008C14 3.2637 13.403 2.66675 12.6667 2.66675Z\" stroke=\"#6C727A\" stroke-width=\"1.6\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M10.6667 1.33325V3.99992\" stroke=\"#6C727A\" stroke-width=\"1.6\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M5.33334 1.33325V3.99992\" stroke=\"#6C727A\" stroke-width=\"1.6\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path><path d=\"M2 6.66675H14\" stroke=\"#6C727A\" stroke-width=\"1.6\" stroke-linecap=\"round\" stroke-linejoin=\"round\"></path></svg></div>", 1)),
                              _createElementVNode("div", _hoisted_24, [
                                _createElementVNode("span", null, _toDisplayString(_ctx.$t('i_will_return')), 1),
                                _createElementVNode("span", null, _toDisplayString(_ctx.ensureDateTimeFormat(booking.dropoff)), 1)
                              ])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_25, [
                            _createElementVNode("span", _hoisted_26, _toDisplayString(booking.tax_total + ' ' + booking.total_currency), 1)
                          ])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true),
              (booking.service_type === _ctx.ServiceTypes.SERVICE_TRANSPORTATION)
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_29, [
                          _createElementVNode("span", _hoisted_30, _toDisplayString('Nr. ' + booking.id) + " - " + _toDisplayString(_ctx.$t('passenger_transportation')) + " (" + _toDisplayString(booking.created_at.split('T')[0]) + ") ", 1),
                          _createElementVNode("div", _hoisted_31, [
                            (booking.payment && booking.service_type === 'transportation')
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 0,
                                  class: "purchase-history__ticket__top__actions",
                                  onClick: ($event: any) => (_ctx.handleDownloadTicket(booking))
                                }, _toDisplayString(_ctx.$t('download_ticket')), 9, _hoisted_32))
                              : _createCommentVNode("", true),
                            (!booking.payment && _ctx.isBookingPickupDateLaterThanToday(booking))
                              ? (_openBlock(), _createElementBlock("span", {
                                  key: 1,
                                  class: "purchase-history__ticket__top__actions",
                                  onClick: ($event: any) => (_ctx.handlePayTheTransportationBooking(booking))
                                }, _toDisplayString(_ctx.$t('pay_order')), 9, _hoisted_33))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_34, [
                          _createElementVNode("div", _hoisted_35, [
                            _createElementVNode("span", _hoisted_36, _toDisplayString(booking.pickup_addr) + " - " + _toDisplayString(booking.dest_addr), 1),
                            _createElementVNode("span", _hoisted_37, _toDisplayString(booking.journey_date), 1)
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_38, [
                          _createElementVNode("div", _hoisted_39, [
                            _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.ensureDateTimeFormat(booking.pickup)), 1)
                          ]),
                          _createElementVNode("div", _hoisted_41, [
                            _createElementVNode("span", _hoisted_42, _toDisplayString(booking.tax_total/booking.travellers + ' ' + booking.total_currency + ' x ' + booking.travellers), 1)
                          ])
                        ])
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          }), 256))
        ])
      ])
    ])
  ]))
}